import React from 'react';
import { Modal } from '@mantine/core';
import { takeAwayChannelLabel, type OrderView } from 'shared-models/browser';
import { TenbisOrderPanel } from './TenbisOrderPanel';

type TenbisOrderModalProps = {
  order: OrderView | null;
  tenantId: string;
  employeeSession: string | null;
  onClose: () => void;
  onAccepted?: (order: OrderView) => void;
};

// List-row entry point (incl. the paid list, where accepted TenBis-paid orders await יצא למשלוח).
export const TenbisOrderModal: React.FC<TenbisOrderModalProps> = ({ order, tenantId, employeeSession, onClose, onAccepted }) => (
  <Modal
    opened={order !== null}
    onClose={onClose}
    title={order ? `הזמנת ${takeAwayChannelLabel(order.orderCode)} ${order.orderCode}` : ''}
    centered
    radius="md"
    size="md"
    zIndex={301}
    closeButtonProps={{ 'data-testid': 'tenbis-order-modal-close' } as Record<string, string>}
  >
    {order && (
      <TenbisOrderPanel tenantId={tenantId} employeeSession={employeeSession} order={order} onAccepted={onAccepted} />
    )}
  </Modal>
);
